<template>
    <div v-for="(step, index) of steps" :class="'item ' + (isOdd(index) ? 'right' : 'left')" :key="step">
        <div class="bullet" :class="step.ad ? 'hasAd' : null">
            {{ step['ad'] ? '' : index + 1 > 4 ? index : index + 1 }}
        </div>
        <div class="content">
            <template v-if="step.ad">
                <span class="box-label-step">Unsere Partner-Empfehlung</span>
                <div class="gruendercockpit-hint aa02">
                    <div class="inner">
                        <div class="logo">
                            <img :src="step['logo']" :alt="step.title" />
                        </div>
                        <div class="side-content">
                            <h3 class="headline headline--4">{{ step.title }}</h3>
                            <div class="bodytext">
                                <ul class="list list--arrow">
                                    <li v-for="bullet of step.bullet" :key="bullet">
                                        <span>{{ bullet }}</span>
                                    </li>
                                </ul>
                            </div>

                            <a
                                :href="step.link.target"
                                class="btn btn--fullwidth btn--small"
                                rel="nofollow"
                                target="_blank"
                            >
                                <span class="label">{{ step.link.label }}</span>
                                <span class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" data-v-3c995187="">
                                        <path
                                            d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm0,22.52L9,16h3.86V7.48h4.24V16h4Z"
                                            data-v-3c995187=""
                                        ></path>
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <h2 class="headline headline--2">{{ step['name'] }}</h2>
                <div class="bodytext" v-html="step['text']"></div>
                <a v-if="step['link']" :href="step['link']" class="btn btn--fullwidth" target="_blank"
                    >{{ step['linklabel'] ? step['linklabel'] : 'Weitere Infos' }}
                </a>
            </template>
        </div>
        <div v-if="step['tipps']" class="tipps">
            <div class="headline headline--2">
                <span class="foto">
                    <img src="@/assets/rene.jpg" />
                </span>
                <span class="label">Mein Tipp</span>
            </div>
            <div class="bodytext">
                <div v-html="step['tipps']"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Steps',
    props: {
        steps: Array,
    },
    data() {
        return {
            addCount: 0,
        }
    },
    mounted() {
        const bottomImage = document.querySelector('.partner-image')
        if (bottomImage) {
            bottomImage.style.display = 'block'
        }
    },
    methods: {
        isOdd(num) {
            return num % 2
        },
        filterCheckboxes() {},
        riseAddCount() {
            alert('addCount: ' + this.addCount)
            this.addCount = this.addCount + 1
            return this.addCount
        },
    },
}
</script>
